import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './EmployeePayForm.scss';

const AttendanceField = ({ input, meta: { touched, error }, toDisplayFormat, toDbFormat }) => {
  const { t } = useTranslation();
  const [displayValue, setDisplayValue] = useState(() => toDisplayFormat(input.value));

  useEffect(
    () => {
      setDisplayValue(prev => {
        const normalizedPrev = toDbFormat(prev);
        return input.value !== normalizedPrev ? toDisplayFormat(input.value) : prev;
      });
    },
    [input.value]
  );

  const handleChange = e => {
    const inputValue = e.target.value;
    setDisplayValue(inputValue);
    input.onChange(toDbFormat(inputValue));
  };

  return (
    <div {...(touched && error ? { className: `invalid ${styles.attendanceField}` } : { className: styles.attendanceField })}>
      <input {...input} value={displayValue} onChange={handleChange} />
      {touched && error && <p className={styles.error}>{t('features.EmployeePays.components.AttendanceField.the_format_is_incorrect')}</p>}
    </div>
  );
};

export default AttendanceField;
